import { useEffect, useContext } from 'react';
import { getCampaignLinks } from '../services/index.service';
import { storeContext } from '../../provider/Provider';
import { digitalPRActions } from '../../../store/digital-pr-reducer';

const useLoadLinksDialog = () => {
   const { state, dispatch } = useContext(storeContext);

   useEffect(() => {
      const fetchLinkList = async () => {
        if(state.digitalPR.selectedCampaign){
            dispatch({
                type: digitalPRActions.SET_LINKS_LOADING,
                payload: { 
                      linksLoading: true,
                   },
             });
             try {
                 const res = await getCampaignLinks(state.digitalPR.selectedCampaign.id);
                 if (!res.data) {
                     return;
                 }
                 
                dispatch({
                   type: digitalPRActions.SET_LINK_LIST,
                   payload: { 
                      linkList: res.data?.results,
                   }
                });
             } finally {
                dispatch({
                   type: digitalPRActions.SET_LINKS_LOADING,
                   payload: { 
                      linksLoading: false,
                   }
                });
             }
        }
     }
     fetchLinkList();
   }, [
    state.digitalPR.selectedCampaign
   ])
}

export default useLoadLinksDialog